import { render, staticRenderFns } from "./IntranetAdminRequestPage.vue?vue&type=template&id=19e00078&"
import script from "./IntranetAdminRequestPage.vue?vue&type=script&lang=js&"
export * from "./IntranetAdminRequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports